import React, { useEffect, useState } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { Polyline } from "main/javascripts/components/googleMap/Polyline";

export interface IProps {
  coordinates: any[];
}

export const CruiseRouteListMapPolyline: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { coordinates } = props;
  const [encodedPath, setEncodedPath] = useState<string>();

  const geometryLib = useMapsLibrary("geometry");
  useEffect(() => {
    if (!geometryLib || !coordinates) {
      return;
    }
    const path = geometryLib.encoding.encodePath(coordinates);
    setEncodedPath(path);
  }, [geometryLib]);

  return <Polyline strokeWeight={2} encodedPath={encodedPath} />;
};
